<template>
    <v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="display-1 text-center primary--text font-weight-medium mt-8">JOBS BY CATEGORY</div>

        <div class="text-center">
            <v-btn text class="accent--text" @click="$router.push('/map-of-careers')">
                <v-icon small color="accent" left>fa-angle-left</v-icon>
                Back to menu
            </v-btn>
        </div> 

        <v-divider class="mt-3 mb-6"></v-divider>

        <v-row>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op1.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op2.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op3.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op4.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op5.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op6.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op7.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op8.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op9.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op10.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op11.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op12.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op13.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op14.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <div style="cursor:pointer">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op15.png')" width="210" contain></v-img>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div style="cursor:pointer" @click="$router.push('/map-of-careers/jobs-by-category/professions-of-future')">
                    <v-img :src="require('@/assets/careers/jobs-by-categories/op16.png')" width="210" contain></v-img>
                </div>
            </v-col>
        </v-row>



        <SendingLoader v-if="!loaded" />
    </v-card>
</template>

<script>

export default {
    data: () => ({
        loaded: true,
    })
}
</script>